import { ReferenceRateInfoData } from '@shared/sec-loans'
import { OptionalAndNullable } from '@shared/typeHelpers'
import { convertUndefinedToNull } from '@ui-common/utils/form'

import { ReferenceRateStepInfoData, StepDataValidator } from '../../../types'
import { isFormDataValid } from '../../../wizardData'
import { createFormValidator } from './formValidator'
import { ReferenceRateInfoFormData } from './types'

export const getAndValidateReferenceRateInfoTypeData: StepDataValidator<ReferenceRateInfoData | undefined> = ({
  validationData,
}) => {
  return isFormDataValid(validationData.loanInfo?.referenceRateInfoData, createFormValidator)
    ? validationData.loanInfo?.referenceRateInfoData
    : undefined
}

export const convertToFormValues = (
  referenceRateInfoData: ReferenceRateStepInfoData | undefined,
): OptionalAndNullable<ReferenceRateInfoFormData> => {
  const data = {
    referenceRate: referenceRateInfoData?.referenceRate,
  }
  return convertUndefinedToNull(data)
}
